import { textStyles } from '../style'
import React, { useContext, useRef } from 'react'
import { ScrollView, Text, View } from 'react-native'
import FeaturedTags from '../featured-tags'
import { MAX_CONTENT_WIDTH } from '../config'
import AddCompanyForm from '../add-company-form'
import { ThemeContext } from '../utility/context/ThemeContext'
import { CustomActionSheet, CustomActionSheetRef } from '../utility/CustomActionSheet'
import { MaterialIcons } from '@expo/vector-icons'
import { ThemedButton } from '../utility/input/buttons'
import { useAppSelector } from '../store'
import { ExploreFeaturedTagsSkeleton } from './explore-skeleton'

const SearchPage = (): React.ReactElement => {
  const bottomSheetModalRef = useRef<CustomActionSheetRef>(null)

  const theme = useContext(ThemeContext).theme
  const {textMain, bgMain} = theme.colors

  const { status: featuredTagsStatus } = useAppSelector(s => s.featuredTags)
  const featuredTagsLoading = featuredTagsStatus === 'idle' || featuredTagsStatus === 'loading'

  return (
    <>
      <View style={{flex: 1, alignSelf: "center", width: "100%", backgroundColor: bgMain}}>
        <ScrollView
          style={{flex: 1}}
          bounces={false}
          contentContainerStyle={{
            paddingTop: 20,
            alignSelf: "center",
            width: "100%",
            maxWidth: MAX_CONTENT_WIDTH,
            paddingHorizontal: 16
          }}
        >
          {featuredTagsLoading ? (
            <ExploreFeaturedTagsSkeleton sectionCount={4} cardsPerSection={8} />
          ) : (
            <>
              <FeaturedTags />
              <View style={{ flexDirection: 'row', alignItems: 'center', padding: 20 }}>
                <Text style={[textStyles.body, {flex: 1, textAlign: "center", paddingHorizontal: 10, color: textMain}]}>
                  Can&apos;t find a business you&apos;re looking for?
                </Text>
                <ThemedButton
                  text="Add Business"
                  onPress={() => bottomSheetModalRef.current?.show()}
                  variant="icon"
                  hapticLevel="Soft"
                  containerStyle={{
                    flex: 1,
                  }}
                  Icon={() => <MaterialIcons name="add-circle" size={20} color={theme.colors.white} />}
                />

              </View>
            </>
          )}
        </ScrollView>
      </View>
      <CustomActionSheet ref={bottomSheetModalRef} name="add-company">
        <AddCompanyForm closeSheet={() => bottomSheetModalRef.current?.hide()} />
      </CustomActionSheet>
    </>
  )
}

export default SearchPage
